import React,{useState,useEffect} from "react";
import {Modal,Button,Form} from "react-bootstrap";

export default function EditProjectModal({
show,
handleClose,
project,
updateProject
}){

const [form,setForm]=useState({});

useEffect(()=>{
if(project)setForm(project)
},[project])

const save=()=>{
updateProject(form)
handleClose()
}

if(!project) return null;

return(

<Modal show={show} onHide={handleClose} centered>

<Modal.Header closeButton>
<Modal.Title>Edit Project</Modal.Title>
</Modal.Header>

<Modal.Body>

<Form.Control
className="mb-2"
value={form.title||""}
onChange={(e)=>setForm({...form,title:e.target.value})}
/>

<Form.Select
value={form.priority||""}
onChange={(e)=>setForm({...form,priority:e.target.value})}
>

<option>Low</option>
<option>Medium</option>
<option>High</option>

</Form.Select>

</Modal.Body>

<Modal.Footer>

<Button variant="secondary" onClick={handleClose}>
Cancel
</Button>

<Button onClick={save}>
Update
</Button>

</Modal.Footer>

</Modal>

)

}